/**
 * Function help to handle ontransitionend event with promise
 */
export const onTransitionEnd = ($element = null) => {
    return new Promise((resolve) => {
        const handler = () => {
            $element.removeEventListener('transitionend', handler);
            document.body.offsetHeight;
            resolve();
        };
        $element.addEventListener('transitionend', handler);
    });
};



// WEBPACK FOOTER //
// ./front/treasurybond/js/helpers/ontransitionend.js